import { Drawer, Stack } from '@mantine/core';
import { useShallow } from 'zustand/react/shallow';
import { FlowDrawerHeader } from '@/components/flow-drawer/components/flow-drawer-header';
import FlowItemForm from '@/components/flow-item-form';
import useFlow from '@/hooks/use-flow';
import useAppStore, { NotificationOperation } from '@/store/app.ts';
import useFlowStore from '@/store/flow';
import type { TGroupItemFrontend } from '@/types/common';

const drawerStyles = {
	body: {
		height: '100%'
	}
};
const FlowDrawer = () => {
	const setNotification = useAppStore((state) => state.setNotification);
	const { flowDrawer, closeFlowDrawer, updateItem, isComparingMode, addItem } =
		useFlowStore(
			useShallow((state) => ({
				flowDrawer: state.flowDrawer,
				isComparingMode: state.flowDrawer.isComparingMode,
				closeFlowDrawer: state.closeFlowDrawer,
				updateItem: state.updateItem,
				addItem: state.addItem
			}))
		);
	const flowItem = flowDrawer.flowItem;

	const isEdit = !!flowItem?.source.idn;
	const { saveItem } = useFlow();

	const handleClose = () => {
		closeFlowDrawer();
	};

	const handleSubmit = (type: string, data: TGroupItemFrontend) => {
		if (!isEdit) {
			addItem(type, data);
			saveItem(data, type);
			closeFlowDrawer();
			setNotification({
				data,
				operation: NotificationOperation.CREATE
			});
			return;
		}

		updateItem(type, data);
		saveItem(data, type);
		setNotification({
			data,
			operation: NotificationOperation.UPDATE
		});
	};

	return (
		<Drawer
			onClose={handleClose}
			opened={flowDrawer.isOpen}
			position="right"
			size={isComparingMode ? '90%' : '55%'}
			styles={drawerStyles}
			withCloseButton={false}
		>
			<Stack
				className="notranslate"
				gap={24}
				h="100%"
				translate="no"
			>
				<Drawer.Title
					component="div"
					w="100%"
				>
					<FlowDrawerHeader />
				</Drawer.Title>
				<FlowItemForm
					flowItem={flowItem}
					isEdit={isEdit}
					onCancel={handleClose}
					onSubmit={handleSubmit}
					type={flowDrawer.groupType}
				/>
			</Stack>
		</Drawer>
	);
};

export default FlowDrawer;
